import { render, staticRenderFns } from "./InventoriesCompanyLocationsList.vue?vue&type=template&id=701311f8&scoped=true&"
import script from "./InventoriesCompanyLocationsList.vue?vue&type=script&lang=ts&"
export * from "./InventoriesCompanyLocationsList.vue?vue&type=script&lang=ts&"
import style0 from "./InventoriesCompanyLocationsList.vue?vue&type=style&index=0&id=701311f8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "701311f8",
  null
  
)

export default component.exports